<template>
  <page
    :custom-style="{
      backgroundColor: '#fff',
      minHeight: '100vh'
    }"
  >
    <div class="page-content">
      <van-search
        v-model="searchValue"
        class="platform-rules-search"
        shape="round"
        background="#fff"
        placeholder="资质标题"
        @input="handleSearchInput"
        @search="handleSearch"
      />

      <div class="tabs-panel">
        <van-tabs
          v-model="activeTab"
          class="rule-tabs"
          animated
          swipeable
          sticky
          :offset-top="stickyTop"
          :swipe-threshold="3"
          line-width="20px"
          title-active-color="#262626"
          title-inactive-color="#595959"
          @change="handleTabChange"
        >
          <van-tab
            v-for="(tab, tabIndex) in tabs"
            :key="tab.tabCode || tab.key"
            :title="tab.title"
            :name="tabIndex"
          >
            <div class="tab-pane">
              <van-loading v-if="isLoading" class="loading-block" />
              <template v-else>
                <div
                  v-for="(section, sectionIndex) in ruleSections"
                  :key="section.title || sectionIndex"
                  class="rule-section"
                >
                  <div
                    v-if="section.title"
                    class="section-title"
                    @click="toggleSection(section)"
                  >
                    <span class="section-title-text">{{ section.title }}</span>
                    <span
                      v-if="isCollapsibleSection(section)"
                      class="section-title-arrow"
                      :class="{ expanded: section.expanded }"
                    >
                      <img
                        src="@/images/cms/common/arrow_up_gray.png"
                        alt="toggle"
                        class="section-title-arrow-icon"
                      />
                    </span>
                  </div>
                  <div
                    v-for="item in getVisibleItems(section)"
                    :key="`${section.title || 'default'}-${item.url || item.title}`"
                    class="rule-card"
                    @click="handleRuleCardClick(item)"
                  >
                    <div class="rule-main">
                      <div class="rule-name">{{ item.title }}</div>
                      <div
                        v-if="
                          !section.title &&
                            item.categoryName &&
                            currentTab.key !== 'qualification' &&
                            currentTab.key !== 'publicized'
                        "
                        class="rule-meta"
                      >
                        {{ item.categoryName }}
                      </div>
                      <div
                        v-if="currentTab.key === 'soliciting' && item.suggestEndTime"
                        class="rule-meta"
                      >
                        截止时间：{{ formatSuggestEndTime(item.suggestEndTime) }}
                      </div>
                    </div>
                    <div
                      v-if="currentTab.key !== 'soliciting'"
                      class="actions actions--single"
                    >
                      <div class="action-link" @click.stop="handleActionClick(item)">
                        {{ getActionText(item) }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="!hasRules" class="empty-state">
                  暂无规则
                </div>
              </template>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <van-popup
      v-model="showSolicitingPopup"
      class="soliciting-popup"
      position="bottom"
      :style="{ height: '100%' }"
    >
      <div class="soliciting-popup-header">
        <div class="popup-close" @click="closeSolicitingPopup">关闭</div>
        <div class="popup-title">
          {{ solicitingPopupItem ? solicitingPopupItem.title : '意见征集中' }}
        </div>
        <div class="popup-placeholder"></div>
      </div>
      <div class="soliciting-popup-body">
        <iframe
          v-if="solicitingPopupUrl"
          :src="solicitingPopupUrl"
          class="soliciting-iframe"
          frameborder="0"
          scrolling="auto"
        ></iframe>
        <div v-else class="empty-state popup-empty-state">暂无内容</div>
      </div>
      <div class="soliciting-popup-footer">
        <div class="soliciting-footer-btn" @click="handleSupport(solicitingPopupItem)">
          支持
        </div>
        <div class="soliciting-footer-btn" @click="handleSuggest(solicitingPopupItem)">
          提意见
        </div>
      </div>
    </van-popup>
  </page>
</template>

<script>
import dayjs from 'dayjs'
import { Bridge } from '@mc/mc-jsbridge'
import {
  isMCMallKeyCustomerIOS,
  isMCMallKeyCustomerAndroid
} from '@mc/mc-base-env/src/web/platform'
import { API } from '@/api'
import { navBar } from '@/utils/native_interactions/native_bar'

const PRIMARY_TABS = [
  {
    key: 'qualification',
    title: '规则与资质',
    aliases: [
      'merchantTab',
      'qualificationTab',
      'rulesQualificationTab',
      '资质与规则',
      '规则与资质'
    ]
  },
  {
    key: 'publicized',
    title: '生效平台规则',
    aliases: ['publicizedTab', 'publishedTab', 'noticeTab', '已公示规则']
  },
  {
    key: 'soliciting',
    title: '意见征集中',
    aliases: ['solicitingTab', 'opinionTab', 'suggestTab', '意见征集中']
  },
  {
    key: 'topic',
    title: '规则话题',
    aliases: ['topicTab', 'topicsTab', 'ruleTopicTab', '规则话题']
  }
]

export default {
  name: 'PlatformRules',
  beforeRouteEnter(to, from, next) {
    next(vm => {
      navBar.setTitle({
        text: '平台规则'
      })
      document.title = '平台规则'
    })
  },
  data() {
    return {
      activeTab: 0,
      searchValue: '',
      isLoading: false,
      researchUrl: '',
      tabs: PRIMARY_TABS.map(item => ({
        ...item,
        tabCode: '',
        categories: []
      })),
      ruleSections: [],
      searchTimer: null,
      showSolicitingPopup: false,
      solicitingPopupItem: null,
      browerInfo: window.matrix || {},
      isMCMallKeyCustomer:
        isMCMallKeyCustomerIOS() || isMCMallKeyCustomerAndroid()
    }
  },
  computed: {
    stickyTop() {
      return 0
    },
    currentTab() {
      return this.tabs[this.activeTab] || this.tabs[0] || {}
    },
    activeTabCode() {
      return this.currentTab.tabCode || ''
    },
    canUseNativeDownload() {
      return this.browerInfo.isMallApp || this.isMCMallKeyCustomer
    },
    hasRules() {
      return this.ruleSections.some(section => Array.isArray(section.items) && section.items.length)
    },
    requestTitle() {
      return this.activeTab === 0 ? this.searchValue.trim() : ''
    },
    solicitingPopupUrl() {
      return this.solicitingPopupItem?.url || ''
    }
  },
  created() {
    this.getCategoryList()
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer)
  },
  methods: {
    handleSearch() {
      this.activeTab = 0
      this.getRules()
    },
    handleSearchInput(value) {
      this.searchValue = value
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.activeTab = 0
        this.getRules()
      }, 300)
    },
    handleTabChange() {
      this.getRules()
    },
    async getCategoryList() {
      this.$Loading()
      try {
        const res = await API.cms.getPlatformRulesCategory()
        const categoryList = res?.categoryList || []
        this.researchUrl = res?.researchUrl || ''
        this.tabs = this.buildTabs(categoryList)
        this.activeTab = 0
        await this.getRules()
      } catch (error) {
        this.researchUrl = ''
        this.tabs = PRIMARY_TABS.map(item => ({
          ...item,
          tabCode: '',
          categories: []
        }))
        this.ruleSections = []
        this.$catch(error)
      } finally {
        this.$Loading.hide()
      }
    },
    buildTabs(categoryList) {
      const groupedList = []
      categoryList.forEach(item => {
        const currentTabCode = item.tabCode || ''
        const existed = groupedList.find(group => group.tabCode === currentTabCode)
        if (existed) {
          existed.categories.push(item)
        } else {
          groupedList.push({
            tabCode: currentTabCode,
            categories: [item]
          })
        }
      })

      const assignedTabCodeSet = new Set()
      const tabs = PRIMARY_TABS.map(item => {
        const matchedGroup = groupedList.find(group => {
          return (
            !assignedTabCodeSet.has(group.tabCode) &&
            item.aliases.includes(group.tabCode)
          )
        })
        if (matchedGroup) {
          assignedTabCodeSet.add(matchedGroup.tabCode)
        }
        return {
          ...item,
          tabCode: matchedGroup?.tabCode || '',
          categories: matchedGroup?.categories || []
        }
      })

      groupedList.forEach(group => {
        if (assignedTabCodeSet.has(group.tabCode)) {
          return
        }
        const emptyTab = tabs.find(item => !item.tabCode)
        if (emptyTab) {
          emptyTab.tabCode = group.tabCode
          emptyTab.categories = group.categories
          assignedTabCodeSet.add(group.tabCode)
        }
      })

      return tabs
    },
    async getRules() {
      if (!this.tabs.length) {
        return
      }

      try {
        this.isLoading = true
        const categories = this.currentTab.categories || []
        const hasGroupTitle = categories.some(item => item.title)

        if (this.currentTab.key === 'publicized' || !categories.length || !hasGroupTitle) {
          const res = await API.cms.getPlatformRules({
            categoryCode: '',
            tabCode: this.activeTabCode,
            title: this.requestTitle
          })
          this.ruleSections = [
            {
              title: '',
              expanded: true,
              items: this.formatRules(res?.rules || [], {
                categories
              })
            }
          ]
          return
        }

        const sectionResults = await Promise.all(
          categories.map(async category => {
            const res = await API.cms.getPlatformRules({
              categoryCode: category.code === 'all' ? '' : category.code || '',
              tabCode: category.code === 'all' ? this.activeTabCode : '',
              title: this.requestTitle
            })
            return {
              title: category.title || '',
              expanded: true,
              items: this.formatRules(res?.rules || [], {
                researchUrl: category.researchUrl || '',
                categoryTitle: category.title || '',
                categories
              })
            }
          })
        )
        this.ruleSections = sectionResults.filter(section => section.items.length)
      } catch (error) {
        this.ruleSections = []
        this.$catch(error)
      } finally {
        this.isLoading = false
      }
    },
    formatRules(rules, extra = {}) {
      return (rules || [])
        .map(item => ({
          title: item.title || '',
          url: item.url || '',
          downloadUrl: item.downloadUrl || '',
          categoryName: item.categoryName || '',
          researchUrl: this.researchUrl || '',
          suggestEndTime: item.suggestEndTime || 0,
          sort: Number(item.sort) || 0
        }))
        .sort((prev, next) => next.sort - prev.sort)
    },
    isCollapsibleSection(section) {
      if (!section.title) {
        return false
      }

      if (this.currentTab.key === 'qualification') {
        return true
      }

      return section.items.length > 1
    },
    getVisibleItems(section) {
      if (!this.isCollapsibleSection(section) || section.expanded) {
        return section.items
      }
      return []
    },
    toggleSection(section) {
      if (!this.isCollapsibleSection(section)) {
        return
      }
      section.expanded = !section.expanded
    },
    openTarget(url) {
      if (!url) {
        this.$toast('暂未配置跳转地址')
        return
      }
      this.$autoRedirect(url)
    },
    handleRuleCardClick(item) {
      if (this.currentTab.key === 'soliciting') {
        this.openSolicitingPopup(item)
        return
      }

      this.openTarget(item.url)
    },
    openSolicitingPopup(item) {
      if (!item || !item.url) {
        this.$toast('暂未配置跳转地址')
        return
      }
      this.solicitingPopupItem = item
      this.showSolicitingPopup = true
    },
    closeSolicitingPopup() {
      this.showSolicitingPopup = false
      this.solicitingPopupItem = null
    },
    handleActionClick(item) {
      if (this.canUseNativeDownload && item.downloadUrl) {
        this.downloadRule(item)
        return
      }

      this.openTarget(item.url)
    },
    handleSupport(item) {
      if (!item) {
        return
      }
      this.$toast('已支持')
      this.closeSolicitingPopup()
    },
    handleSuggest(item) {
      if (!item) {
        return
      }
      const suggestUrl = this.buildSuggestUrl(item)
      if (!suggestUrl) {
        return
      }
      this.openTarget(suggestUrl)
    },
    buildSuggestUrl(item) {
      const baseUrl = item?.researchUrl || ''
      const sourceUrl = item?.url || ''
      if (!baseUrl) {
        this.$toast('暂未配置提意见地址')
        return ''
      }

      const separator = baseUrl.includes('?') ? '&' : '?'
      return `${baseUrl}${separator}sourceUrl=${encodeURIComponent(
        sourceUrl
      )}`
    },
    getActionText(item) {
      return this.canUseNativeDownload && item.downloadUrl ? '下载' : '查看'
    },
    formatSuggestEndTime(time) {
      if (!time) {
        return ''
      }

      const timestamp = String(time).length === 13 ? Number(time) : Number(time) * 1000
      return dayjs(timestamp).format('YYYY-MM-DD')
    },
    downloadRule(item) {
      const url = item.downloadUrl || item.url
      if (!url) {
        this.$toast('暂未配置下载地址')
        return
      }

      if (this.browerInfo.isMiniProgram) {
        this.$dialog.alert({
          message: '小程序不支持下载，请去APP端下载'
        })
        return
      }

      if (this.canUseNativeDownload) {
        Bridge.call(
          'systemShare',
          {
            fileURL: url,
            fileName: this.getDownloadFileName(item, url)
          },
          res => {
            if (res?.ret) {
              this.$Dialog.alert('下载成功')
            } else {
              this.$Dialog.alert('下载失败')
            }
          }
        )
        return
      }

      this.openTarget(url)
    },
    getDownloadFileName(item, url) {
      const title = item?.title || '平台规则'
      const matchedExt = (url || '').match(/\.(pdf|doc|docx|xls|xlsx|ppt|pptx|zip)(\?|$)/i)
      const extension = matchedExt?.[1] || 'pdf'
      return `${title}.${extension}`
    }
  }
}
</script>

<style scoped lang="scss">
.page-content {
  min-height: 100vh;
  padding: 0 0 0.4rem;
  background: #ffffff;
  box-sizing: border-box;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.platform-rules-search {
  background: #ffffff !important;
  padding: 0.16rem 0.12rem 0.08rem;
  border-bottom: 1px solid #f2f2f2;

  ::v-deep .van-search {
    background: transparent;
    padding: 0 0.1rem;
  }

  ::v-deep .van-search__content {
    height: 0.7rem;
    border: 1px solid #07c160 !important;
    border-radius: 0.48rem !important;
    background-color: #f7f8fa !important;
    box-sizing: border-box;
    overflow: hidden;
  }

  ::v-deep .van-search__content:focus-within {
    border-color: #07c160 !important;
  }

  ::v-deep .van-field__left-icon {
    margin-right: 0.12rem;
    color: #bfbfbf;
  }

  ::v-deep .van-field__control {
    font-size: 0.28rem;
    color: #262626;
  }

  ::v-deep .van-field__control::placeholder {
    color: #bfbfbf;
  }

  ::v-deep .van-icon-clear {
    color: #bfbfbf;
  }
}

.tabs-panel {
  overflow: hidden;
}

.rule-tabs {
  ::v-deep .van-tabs__wrap {
    background: #ffffff;
    border-bottom: 1px solid #f2f2f2;
  }

  ::v-deep .van-tab {
    flex: initial;
    min-width: auto;
    padding: 0 0.12rem;
    font-size: 0.28rem;
    white-space: nowrap;
  }

  ::v-deep .van-tabs__nav {
    padding: 0 0.04rem;
  }

  ::v-deep .van-tabs__nav--line {
    padding-bottom: 0.02rem;
  }

  ::v-deep .van-tab--active {
    font-weight: 600;
  }

  ::v-deep .van-tabs__line {
    bottom: 0.16rem;
    height: 0.04rem;
    background: #0daf52;
  }
}

.tab-pane {
  min-height: calc(100vh - 1.84rem);
  padding: 0 0.24rem 0.56rem;
  box-sizing: border-box;
}

.rule-section {
  .section-title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0.32rem 0 0.08rem;
    padding-right: 1rem;
    font-size: 0.28rem;
    font-weight: 600;
    line-height: 0.4rem;
    color: #262626;
    cursor: pointer;
  }

  .section-title-text {
    flex: 1;
    min-width: 0;
  }

  .section-title-arrow {
    position: absolute;
    top: 50%;
    right: 0.24rem;
    display: flex;
    width: 0.32rem;
    height: 0.32rem;
    margin-left: 0;
    transform: translateY(-50%) rotate(180deg);
    transition: transform 0.2s ease;
    align-items: center;
    justify-content: center;
    transform-origin: center;

    &.expanded {
      transform: translateY(-50%) rotate(0deg);
    }
  }

  .section-title-arrow-icon {
    display: block;
    width: 0.28rem;
    height: 0.16rem;
  }
}

.loading-block {
  display: flex;
  justify-content: center;
  padding-top: 1rem;
}

.rule-card {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0.32rem 0;
  margin-bottom: 0;
  background: #ffffff;
  border-bottom: 1px solid #f2f2f2;

  &--interactive {
    cursor: pointer;
  }

  .rule-main {
    flex: 1;
    min-width: 0;
    padding-right: 0.12rem;
  }

  .rule-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .rule-name {
    flex: 1;
    font-size: 0.26rem;
    font-weight: 400;
    line-height: 0.38rem;
    color: #262626;
    word-break: break-all;
  }

  .rule-meta {
    padding-top: 0.12rem;
    font-size: 0.24rem;
    line-height: 0.34rem;
    color: #8c8c8c;
  }

}

.actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.actions--single {
  align-self: center;
}

.action-link {
  display: flex;
  min-width: 0.84rem;
  padding-left: 0.16rem;
  align-items: center;
  justify-content: center;
  font-size: 0.24rem;
  line-height: 0.34rem;
  color: #0daf52;
  box-sizing: border-box;

  &--disabled {
    color: #bfbfbf;
  }
}

.empty-state {
  padding: 1.2rem 0 0.8rem;
  font-size: 0.28rem;
  text-align: center;
  color: #8c8c8c;
}

.soliciting-popup {
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

.soliciting-popup-header {
  display: flex;
  height: 0.96rem;
  padding: 0 0.24rem;
  border-bottom: 1px solid #f2f2f2;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.popup-close,
.popup-placeholder {
  width: 1rem;
  font-size: 0.28rem;
  color: #8c8c8c;
}

.popup-title {
  flex: 1;
  min-width: 0;
  font-size: 0.32rem;
  font-weight: 500;
  text-align: center;
  color: #262626;
  @include text-overflow-ellipsis;
}

.popup-placeholder {
  visibility: hidden;
}

.soliciting-popup-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.soliciting-iframe {
  display: block;
  width: 100%;
  height: 100%;
  background: #ffffff;
}

.soliciting-popup-footer {
  display: flex;
  flex-shrink: 0;
  padding: 0.2rem 0.24rem calc(0.2rem + env(safe-area-inset-bottom));
  background: #ffffff;
  box-shadow: 0 -0.04rem 0.16rem rgba(31, 35, 41, 0.06);
  gap: 0.16rem;
}

.soliciting-footer-btn {
  display: flex;
  flex: 1;
  height: 0.8rem;
  background: #15bb5c;
  border-radius: 0.16rem;
  align-items: center;
  justify-content: center;
  font-size: 0.3rem;
  font-weight: 500;
  color: #ffffff;
}

.popup-empty-state {
  padding-top: 2rem;
}
</style>
